module.exports = __webpack_public_path__ + "static/media/lucky.d6d68c10.mp3";